import { createReducer } from "@reduxjs/toolkit"

const loadingReducer = createReducer(false, {
  SET_LOADING: (state, action) => action.payload,
})

export default loadingReducer
